<div class="content-wrap">
    <div class="container">
        <div class="breadcrumb">
            <app-bread-crumb [data]="breadCrumb"></app-bread-crumb>
        </div>
        <div class="title-catalogue d-flex justify-content-between align-items-center">
            <h2>{{ 'IRONSIDE.download-page.downloads' | translate | uppercase }}</h2>
        </div>
    </div>
</div>
<div class="container contact-page-content">
    <div class="content-wrap">
        <p-tabView (activeIndexChange)="onTabChange($event)" [(activeIndex)]="activeIndex">
            <p-tabPanel *ngIf="permissionService.isPermissionFonction('export-informations-commerciales')"
                header="{{ 'IRONSIDE.download-page.flyers' | translate }}">
                <ng-container *ngIf="commercialInformationState.data.length > 0; else elseTemplateCommercial">
                    <div class="container-wrap">
                        <div class="wrapper-commercial" *ngFor="let ci of commercialInformationState.data"
                            (click)="openFile(ci)">
                            <img style="width: 40px" src="src-ironside/assets/icons/file-text.svg" alt="file" width="40"
                                height="50" />
                            <div class="wrap-text truncate">
                                <!-- TITLE FILE -->
                                <ng-container *ngIf="ci?.title; else elseNotTitleFile">
                                    <span class="mb-0 font-bold truncate" style="line-height: 20px"
                                        [pTooltip]="ci?.title!" tooltipPosition="bottom">{{ ci?.title }}</span>
                                </ng-container>
                                <ng-template #elseNotTitleFile>
                                    <span class="mb-0 font-bold truncate" style="line-height: 20px">--</span>
                                </ng-template>

                                <ng-container *ngIf="getNameFile(ci); else elseTemplateNotNameFile">
                                    <span class="truncate" [pTooltip]="getNameFile(ci)!" tooltipPosition="bottom">{{
                                        getNameFile(ci) }}</span>
                                </ng-container>
                                <ng-template #elseTemplateNotNameFile>
                                    <span>--</span>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <app-custom-paginator (onChangePagination)="onChangePagination(0)"
                        [totalRecords]="commercialInformationState.total"
                        [(currentPage)]="commercialInformationState.page"
                        [(pageSize)]="commercialInformationState.pageSize"></app-custom-paginator>
                </ng-container>
                <ng-template #elseTemplateCommercial>
                    <div style="text-align: center">
                        <span>{{ 'common.not-found' | translate }}</span>
                    </div>
                </ng-template>
            </p-tabPanel>
            <p-tabPanel *ngIf="permissionService.isPermissionFonction('export-photos-hd')"
                header="{{ 'IRONSIDE.download-page.ironside-photos' | translate }}">
                <ng-container *ngIf="photoState.data.length > 0; else elseTemplatePhoto">
                    <div class="container-wrap">
                        <div class="wrapper-photo" *ngFor="let photo of photoState.data" (click)="openFile(photo)">
                            <img [src]="photo?.file?.[0]?.url ?? defaultImg" alt="photo" />
                            <div class="wrap-text truncate">
                                <ng-container *ngIf="photo?.title; else elseTemplateNotTitlePhoto">
                                    <span style="font-weight: 600" class="truncate" [pTooltip]="photo?.title!"
                                        tooltipPosition="bottom">{{ photo?.title }}</span>
                                </ng-container>
                                <ng-template #elseTemplateNotTitlePhoto>
                                    <span style="font-weight: 600" class="truncate">--</span>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <app-custom-paginator (onChangePagination)="onChangePagination(1)" [totalRecords]="photoState.total"
                        [(currentPage)]="photoState.page" [(pageSize)]="photoState.pageSize"></app-custom-paginator>
                </ng-container>
                <ng-template #elseTemplatePhoto>
                    <div style="text-align: center">
                        <span>{{ 'common.not-found' | translate }}</span>
                    </div>
                </ng-template>
            </p-tabPanel>
            <p-tabPanel *ngIf="permissionService.isPermissionFonction('export-ressource-videos')"
                header="{{ 'IRONSIDE.download-page.youtube-videos' | translate }}">
                <ng-container *ngIf="videoState.data.length > 0; else elseTemplateVideo">
                    <div class="container-wrap">
                        <div class="wrapper-video" (click)="openFile(video)" *ngFor="let video of videoState.data">
                            <div class="wrap-iframe-youtube">
                                <iframe width="250" height="186" [src]="sanitizeUrl(video.urlYoutube ?? '')"
                                    frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>
                                </iframe>
                            </div>

                            <!-- <img [src]="getYoutubeThumbnailFromUrl(video?.urlYoutube,'hqdefault')" alt="YouTube Thumbnail" /> -->
                        </div>
                    </div>
                    <app-custom-paginator (onChangePagination)="onChangePagination(2)" [totalRecords]="videoState.total"
                        [(currentPage)]="videoState.page" [(pageSize)]="videoState.pageSize"></app-custom-paginator>
                </ng-container>
                <ng-template #elseTemplateVideo>
                    <div style="text-align: center">
                        <span>{{ 'common.not-found' | translate }}</span>
                    </div>
                </ng-template>
            </p-tabPanel>
        </p-tabView>
    </div>
</div>
<p-dialog header="{{ 'IRONSIDE.download-page.preview-file' | translate }}" [modal]="true" [(visible)]="visibleItem"
    [ngStyle]="{ width: activeIndex === 0 ? '70%' : '50%' }" [style]="{ width: '70%' }">
    <div [ngSwitch]="activeIndex">
        <div *ngSwitchCase="0">
            <div class="popup-del-row">
                <div class="w-100 text-end" style="margin-bottom: 12px">
                    <a href="{{ itemPdfShow?.urlFile }}" class="btn-common p-2">{{
                        'IRONSIDE.download-page.downloads' | translate
                        }}</a>
                </div>
                <div id="outerContainer" *ngIf="itemPdfShow?.urlFile">
                    <div class="pdf-container" [ngClass]="{ loaded: pdfLoaded }">
                        <pdf-viewer [src]="itemPdfShow?.urlFile || defaultImg" [rotation]="0" [original-size]="false"
                            [show-all]="true" [fit-to-page]="false" [zoom]="1" [zoom-scale]="'page-width'"
                            [stick-to-page]="false" [render-text]="true" [external-link-target]="'blank'"
                            [autoresize]="true" [show-borders]="false" style="max-width: 100; width: 101%; height: 70vh"
                            (page-rendered)="pageRendered($event)"
                            (after-load-complete)="pageProgress($event)"></pdf-viewer>
                    </div>
                </div>
            </div>
        </div>

        <div *ngSwitchCase="1">
            <div style="display: flex; flex-direction: column; gap: 20px">
                <div class="w-100 text-end" style="margin-bottom: 12px">
                    <a href="{{ imgShow }}" class="btn-common p-2">{{
                        'IRONSIDE.download-page.downloads' | translate
                        }}</a>
                </div>
                <div class="img-show d-flex justify-content-center align-items-center">
                    <div class="wrap-img-zoom">
                        <!-- <lib-ngx-image-zoom
                            class="mx-auto img custom-zoom"
                            [thumbImage]="imgShow || ''"
                            [fullImage]="imgShow || ''"
                            [magnification]="2"
                            [enableScrollZoom]="false"
                            [enableLens]="true"
                            [lensWidth]="100"
                            [lensHeight]="100"
                            [circularLens]="false"
                        ></lib-ngx-image-zoom> -->
                        <img [src]="imgShow" alt="imgShow" style="max-width: 1000px; object-fit: cover" />
                    </div>
                </div>
            </div>
        </div>
        <div *ngSwitchCase="2">
            <div class="video-container">
                <iframe *ngIf="videoShow" [src]="sanitizeUrl(videoShow)" width="100%" height="500" frameborder="0"
                    allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </div>
        </div>
    </div>
</p-dialog>
<p-toast></p-toast>